<template>
    <v-container class="pt-10 main-store">

        <template v-for="(item, index) in dataMyStore">
            <section :id="item.slug" class="mb-10" :key="index" v-if="item.products.length > 0">
                <div class="wrap-copy2"></div>
                <h2 class="mb-5 text-capitalize font-weight-bold text-h4 text-md-h3 break-word text-center" :class="fontFamily" :style="`color:${titleColor}`">
                    {{ item.name }}
                    <v-btn
                        :color="btnColor"
                        icon
                        @click="copyData2(`/${slug}/#${item.slug}`)"
                    ><v-icon>mdi-link-variant</v-icon></v-btn>
                </h2>

                <products-by-categories
                    :cat="item.id"
                    :emergency="emergency"
                    :sizeBanner="item.size_banner"
                    :titleCardColor="titleCardColor"
                    :contentColor="contentColor"
                    :priceColor="priceColor"
                    :money="money"
                    :btnColor="btnColor"
                    :textbtnColor="textbtnColor"
                    :mobileColumns="mobileColumns"
                    :desktopColumns="desktopColumns"
                    :fun-cart="funCart"
                    :type-store="typeStore"
                    @open-details="(item)=>{openDetails(item)}"
                    v-if="searchProd=='' && ifLoadMore"
                ></products-by-categories>

                <v-row v-else>
                    <v-col :cols="mobileColumns" :sm="(desktopColumns == 2 || desktopColumns == 2.4) ? 4 : 6" :md="(desktopColumns == 2 || desktopColumns == 2.4) ? 3 : 4" :lg="desktopColumns" v-for="(prod, j) in item.products" :key="j">
                        <v-card
                            class="mx-auto"
                            color="grey lighten-4"
                            max-width="600"
                            :disabled="emergency || !prod.available"
                        >
                            <div class="wrap-unavailable" v-if="!prod.available">
                                {{ $t('No disponible') }}
                            </div>
                            <div class="discount-flag" v-if="prod.tag_discount">
                                {{ prod.tag_discount }}
                            </div>
                            <v-img
                                :aspect-ratio="item.size_banner"
                                :src="prod.banner"
                                style="cursor:pointer;"
                                @click="openDetails(prod.id)"
                            >
                                <div class="tag-promo" v-if="prod.promo">{{ $t('Oferta') }}</div>
                            </v-img>
                            <v-card-text
                                class="pt-4 pb-0"
                                style="position: relative;"
                            >
                                <h4 class="font-weight-light mb-0 text-sm-h5 text-subtitle-1 mb-2" :style="{'color':titleCardColor}">
                                    {{ (prod.store_show_name && prod.store_show_name!='null') ? prod.store_show_name : prod.name }}
                                </h4>
                                <v-list-item three-line class="pa-0" v-if="prod.description!='' && prod.description!='null' && prod.description!=null">
                                    <v-list-item-content class="py-0">
                                        <v-list-item-subtitle class="desc_store" :style="{'color':contentColor, 'fontSize':'16px', '-webkit-line-clamp': 4}"
                                            v-html="sanitize(prod.description)"
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card-text>
                            <v-card-actions v-if="prod.price">
                                <div v-if="prod.stock">
                                    {{ $t('Sólo') }} {{ prod.stock }} {{ $t('en stock') }}
                                </div>
                                <v-spacer></v-spacer>
                                <div class="mb-2 text-right" v-if="prod.special_price" :style="{'color':priceColor}">
                                    <span class="font-weight-light text-decoration-line-through grey--text">
                                        {{ money }} {{ (prod.price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                                    </span>
                                    <span class="title">
                                        {{ money }} {{ (prod.special_price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                                    </span>
                                </div>
                                <div class="mb-2 text-right" v-else :style="{'color':priceColor}">
                                    <span class="title">
                                        {{ money }} {{ (prod.price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                                    </span>
                                </div>
                            </v-card-actions>
                            <v-card-actions v-else>
                                <div class="mb-2">&nbsp;</div>
                            </v-card-actions>
                            <v-card-actions v-if="typeStore!='real_estate'" :class="!funCart ? 'pa-0' : ''">
                                <v-spacer></v-spacer>
                                <template v-if="funCart">
                                    <v-btn
                                        :color="btnColor"
                                        :style="{color: textbtnColor, fontSize: (mobileColumns == 6 && $vuetify.breakpoint.xsOnly) ? '9px' : ''}"
                                        @click="openDetails(prod.id)"
                                        v-if="prod.type == 'product'"
                                        :small="(desktopColumns == 2 || desktopColumns == 2.4) || (mobileColumns == 6 && $vuetify.breakpoint.smAndDown)"
                                    >{{ $t('Agregar al carrito') }}</v-btn>
                                </template>
                                <v-btn
                                    :color="btnColor"
                                    :style="{color: textbtnColor}"
                                    @click="openDetails(prod.id)"
                                    v-if="prod.type == 'service'"
                                >{{ $t('Reservar') }}</v-btn>
                            </v-card-actions>
                            <v-card-actions v-if="typeStore=='real_estate'">
                                <v-spacer></v-spacer>
                                <v-btn
                                    :color="btnColor"
                                    :style="{color: textbtnColor, fontSize: (mobileColumns == 6 && $vuetify.breakpoint.xsOnly) ? '9px' : ''}"
                                    @click="openDetails(prod.id)"
                                    v-if="prod.type == 'product'"
                                    :small="(desktopColumns == 2 || desktopColumns == 2.4) || (mobileColumns == 6 && $vuetify.breakpoint.smAndDown)"
                                >{{ $t('Agendar') }}</v-btn>
                                <v-btn
                                    :color="btnColor"
                                    :style="{color: textbtnColor}"
                                    @click="openDetails(prod.id)"
                                    v-if="prod.type == 'service'"
                                >{{ $t('Reservar') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </section>
            <section v-if="item.children.filter(cat => cat.products.length > 0).length > 0">
                <div class="wrap-copy2"></div>
                <h2 class="mb-5 text-capitalize font-weight-bold text-h4 text-md-h3 break-word text-center" :class="fontFamily" :style="`color:${titleColor}`">
                    {{ item.name }}
                    <v-btn
                        :color="btnColor"
                        icon
                        @click="copyData2(`/${slug}/#${item.slug}`)"
                    ><v-icon>mdi-link-variant</v-icon></v-btn>
                </h2>
            </section>
            <!-- SUBCATEGORIAS -->
            <section :id="sub.slug" class="mb-10" v-for="(sub, j) in item.children" :key="'sub'+j" v-if="sub.products.length > 0">
                <h2 class="mb-5 text-capitalize font-weight-bold text-h5 text-md-h4 break-word" :class="fontFamily" :style="`color:${titleColor}`">
                    {{ sub.name }}
                    <v-btn
                        :color="btnColor"
                        icon
                        @click="copyData2(`/${slug}/#${sub.slug}`)"
                    ><v-icon>mdi-link-variant</v-icon></v-btn>
                </h2>

                <products-by-categories
                    :cat="sub.id"
                    :emergency="emergency"
                    :sizeBanner="sub.size_banner"
                    :titleCardColor="titleCardColor"
                    :contentColor="contentColor"
                    :priceColor="priceColor"
                    :money="money"
                    :btnColor="btnColor"
                    :textbtnColor="textbtnColor"
                    :mobileColumns="mobileColumns"
                    :desktopColumns="desktopColumns"
                    :fun-cart="funCart"
                    @open-details="(item)=>{openDetails(item)}"
                    v-if="searchProd=='' && ifLoadMore"
                ></products-by-categories>

                <v-row v-else>
                    <v-col :cols="mobileColumns" :sm="(desktopColumns == 2 || desktopColumns == 2.4) ? 4 : 6" :md="(desktopColumns == 2 || desktopColumns == 2.4) ? 3 : 4" :lg="desktopColumns" v-for="(prod, j) in sub.products" :key="j">
                        <v-card
                            class="mx-auto"
                            color="grey lighten-4"
                            max-width="600"
                            :disabled="emergency || !prod.available"
                        >
                            <div class="wrap-unavailable" v-if="!prod.available">
                                {{ $t('No disponible') }}
                            </div>
                            <div class="discount-flag" v-if="prod.tag_discount">
                                {{ prod.tag_discount }}
                            </div>
                            <v-img
                                :aspect-ratio="sub.size_banner"
                                :src="prod.banner"
                                style="cursor:pointer;"
                                @click="openDetails(prod.id)"
                            >
                                <div class="tag-promo" v-if="prod.promo">{{ $t('Oferta') }}</div>
                            </v-img>
                            <v-card-text
                                class="pt-4 pb-0"
                                style="position: relative;"
                            >
                                <h4 class="font-weight-light mb-0 text-sm-h5 text-subtitle-1" :style="{'color':titleCardColor}">
                                    {{ (prod.store_show_name && prod.store_show_name!='null') ? prod.store_show_name : prod.name }}
                                </h4>
                                <v-list-item three-line class="pa-0">
                                    <v-list-item-content class="py-0">
                                        <v-list-item-subtitle :style="{'color':contentColor, 'fontSize':'16px'}">
                                            <div v-html="sanitize(prod.description)"></div>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card-text>
                            <v-card-actions v-if="prod.price">
                                <div v-if="prod.stock">
                                    {{ $t('Sólo') }} {{ prod.stock }} {{ $t('en stock') }}
                                </div>
                                <v-spacer></v-spacer>
                                <div class="mb-2 text-right" v-if="prod.special_price" :style="{'color':priceColor}">
                                    <span class="font-weight-light text-decoration-line-through grey--text">
                                        {{ money }} {{ (prod.price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                                    </span>
                                    <span class="title">
                                        {{ money }} {{ (prod.special_price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                                    </span>
                                </div>
                                <div class="mb-2 text-right" v-else :style="{'color':priceColor}">
                                    <span class="title">
                                        {{ money }} {{ (prod.price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                                    </span>
                                </div>
                            </v-card-actions>
                            <v-card-actions v-else>
                                <div class="mb-2">&nbsp;</div>
                            </v-card-actions>
                            <v-card-actions :class="!funCart ? 'pa-0' : ''">
                                <v-spacer></v-spacer>
                                <template v-if="funCart">
                                    <v-btn
                                        :color="btnColor"
                                        :style="{color: textbtnColor,fontSize: (mobileColumns == 6 && $vuetify.breakpoint.xsOnly) ? '9px' : ''}"
                                        @click="openDetails(prod.id)"
                                        v-if="prod.type == 'product'"
                                        :small="(desktopColumns == 2 || desktopColumns == 2.4) || (mobileColumns == 6 && $vuetify.breakpoint.smAndDown)"
                                    >{{ $t('Agregar al carrito') }}</v-btn>
                                </template>
                                <v-btn
                                    :color="btnColor"
                                    :style="{color: textbtnColor}"
                                    @click="openDetails(prod.id)"
                                    v-if="prod.type == 'service'"
                                >{{ $t('Reservar') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </section>
            <!-- SUBCATEGORIAS NIVEL 3 -->
            <template v-for="(sub, j) in item.children">
                <section :id="grand.slug" class="mb-10" v-for="(grand, k) in sub.children" :key="'grand'+j+'-'+k" v-if="grand.products.length > 0">
                    <h2 class="mb-5 text-capitalize font-weight-bold text-h5 text-md-h4 break-word" :class="fontFamily" :style="`color:${titleColor}`">
                        {{ grand.name }}
                        <v-btn
                            :color="btnColor"
                            icon
                            @click="copyData2(`/${slug}/#${grand.slug}`)"
                        ><v-icon>mdi-link-variant</v-icon></v-btn>
                    </h2>

                    <products-by-categories
                        :cat="grand.id"
                        :emergency="emergency"
                        :sizeBanner="grand.size_banner"
                        :titleCardColor="titleCardColor"
                        :contentColor="contentColor"
                        :priceColor="priceColor"
                        :money="money"
                        :btnColor="btnColor"
                        :textbtnColor="textbtnColor"
                        :mobileColumns="mobileColumns"
                        :desktopColumns="desktopColumns"
                        :fun-cart="funCart"
                        :type-store="typeStore"
                        @open-details="(item)=>{openDetails(item)}"
                        v-if="searchProd=='' && ifLoadMore"
                    ></products-by-categories>

                    <v-row v-else>
                        <v-col :cols="mobileColumns" :sm="(desktopColumns == 2 || desktopColumns == 2.4) ? 4 : 6" :md="(desktopColumns == 2 || desktopColumns == 2.4) ? 3 : 4" :lg="desktopColumns" v-for="(prod, j) in grand.products" :key="j">
                            <v-card
                                class="mx-auto"
                                color="grey lighten-4"
                                max-width="600"
                                :disabled="emergency || !prod.available"
                            >
                                <div class="wrap-unavailable" v-if="!prod.available">
                                    {{ $t('No disponible') }}
                                </div>
                                <div class="discount-flag" v-if="prod.tag_discount">
                                    {{ prod.tag_discount }}
                                </div>
                                <v-img
                                    :aspect-ratio="grand.size_banner"
                                    :src="prod.banner"
                                    style="cursor:pointer;"
                                    @click="openDetails(prod.id)"
                                >
                                    <div class="tag-promo" v-if="prod.promo">{{ $t('Oferta') }}</div>
                                </v-img>
                                <v-card-text
                                    class="pt-4 pb-0"
                                    style="position: relative;"
                                >
                                    <h4 class="font-weight-light mb-0 text-sm-h5 text-subtitle-1" :style="{'color':titleCardColor}">
                                        {{ (prod.store_show_name && prod.store_show_name!='null') ? prod.store_show_name : prod.name }}
                                    </h4>
                                    <v-list-item three-line class="pa-0">
                                        <v-list-item-content class="py-0">
                                            <v-list-item-subtitle :style="{'color':contentColor, 'fontSize':'16px'}">
                                                <div v-html="sanitize(prod.description)"></div>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-card-text>
                                <v-card-actions v-if="prod.price">
                                    <div v-if="prod.stock">
                                        {{ $t('Sólo') }} {{ prod.stock }} {{ $t('en stock') }}
                                    </div>
                                    <v-spacer></v-spacer>
                                    <div class="mb-2 text-right" v-if="prod.special_price" :style="{'color':priceColor}">
                                        <span class="font-weight-light text-decoration-line-through grey--text">
                                            {{ money }} {{ (prod.price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                                        </span>
                                        <span class="title">
                                            {{ money }} {{ (prod.special_price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                                        </span>
                                    </div>
                                    <div class="mb-2 text-right" v-else :style="{'color':priceColor}">
                                        <span class="title">
                                            {{ money }} {{ (prod.price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                                        </span>
                                    </div>
                                </v-card-actions>
                                <v-card-actions v-else>
                                    <div class="mb-2">&nbsp;</div>
                                </v-card-actions>
                                <v-card-actions :class="!funCart ? 'pa-0' : ''">
                                    <v-spacer></v-spacer>
                                    <template v-if="funCart">
                                        <v-btn
                                            :color="btnColor"
                                            :style="{color: textbtnColor,fontSize: (mobileColumns == 6 && $vuetify.breakpoint.xsOnly) ? '9px' : ''}"
                                            @click="openDetails(prod.id)"
                                            v-if="prod.type == 'product'"
                                            :small="(desktopColumns == 2 || desktopColumns == 2.4) || (mobileColumns == 6 && $vuetify.breakpoint.smAndDown)"
                                        >{{ $t('Agregar al carrito') }}</v-btn>
                                    </template>
                                    <v-btn
                                        :color="btnColor"
                                        :style="{color: textbtnColor}"
                                        @click="openDetails(prod.id)"
                                        v-if="prod.type == 'service'"
                                    >{{ $t('Reservar') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </section>
            </template>
        </template>

        <div class="mb-3" v-if="to < total">
            <v-btn
                x-large
                block
                :color="btnColor"
                outlined
                :loading="loading2"
                @click="$emit('load-more')"
            >{{ $t('Cargar más categorías') }}</v-btn>
        </div>

        <!-- dialog -->
        <v-dialog
            v-model="dialogProd"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-skeleton-loader
                v-if="loadProd"
                class="white"
                type="card-avatar, article, actions"
            ></v-skeleton-loader>
            <v-card
                v-else
                class="mx-auto"
            >
                <v-overlay
                    absolute
                    :value="overlayProd"
                    opacity=".8"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="success"
                    ></v-progress-circular>
                </v-overlay>
                <v-fab-transition>
                    <v-btn
                        absolute
                        right
                        fab
                        small
                        style="top: 10px;"
                        @click="dialogProd=!dialogProd, loadProd=!loadProd"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-fab-transition>

                <v-card-text class="pb-5 px-0">
                    <v-card-title :style="`color:${navColor}`" class="pa-0">
                        <div class="wrap-copy">
                            <v-btn
                                :color="btnColor"
                                text
                                @click="copyData(`/${slug}?product=${prodId}`)"
                            ><v-icon>mdi-link-variant</v-icon> {{ $t('Copiar enlace') }}</v-btn>
                        </div>
                        <v-carousel
                            height="auto"
                            class="simple-carousel"
                            :show-arrows="(galleryProd.length<=0)?false:true"
                            hide-delimiters
                            style="min-height: 250px;"
                            v-if="bannerProd != 'none' || galleryProd.length > 0"
                        >
                            <v-carousel-item
                                class="white"
                                contain
                                v-if="bannerProd != 'none'"
                            >
                                <v-img
                                    :src="bannerProd"
                                    :lazy-src="bannerProd"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                :color="btnColor"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                            <v-carousel-item
                                v-for="img in galleryProd.slice().sort((a, b) => a.order - b.order)"
                                :key="img.id"
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="img.img"
                                    :lazy-src="img.img"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                :color="btnColor"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                        </v-carousel>
                        <div class="px-4 py-2" style="width:100%" :style="{'color':titleCardColor}">
                            {{ (storeShowName && storeShowName!='null') ? storeShowName : nameProd }}
                        </div>
                        <div class="px-4 py-2" style="width:100%" v-if="extraBtn.isBtn">
                            <v-btn
                                rounded
                                :color="btnColor"
                                class="text-capitalize"
                                v-if="extraBtn.typeBtn == 'url'"
                                :href="extraBtn.urlBtn"
                                target="_blank"
                                :style="`color:${textbtnColor}`"
                            >{{ extraBtn.textBtn }}</v-btn>
                            <v-btn
                                rounded
                                :color="btnColor"
                                class="text-capitalize"
                                v-if="extraBtn.typeBtn == 'video'"
                                @click="dialogVideo = true, codeVideo = extraBtn.urlBtn"
                                :style="`color:${textbtnColor}`"
                            >{{ extraBtn.textBtn }}</v-btn>
                        </div>

                    </v-card-title>

                    <div class="px-5 mb-5" v-if="descriptionProd" :style="{'color':contentColor, 'fontSize':'16px'}" v-html="descriptionProd"></div>

                    <template v-for="(row, j) in optionsProd">
                        <v-card-title :key="j" class="py-3" :style="{backgroundColor: navColor, color: textnavColor}">
                            {{ row.title }}
                        </v-card-title>
                        <v-alert
                            :key="j+1*150"
                            dense
                            tile
                            outlined
                            type="error"
                            v-if="showAlertRequired && row.isRequired"
                        >{{ $t('Debe seleccionar una opción para continuar') }}</v-alert>
                        <!-- multiple -->
                        <v-list :key="j+10" v-if="row.type == 'multiple'">
                            <!-- select quantity -->
                            <template dense>
                                <v-list-item :disabled="!opt.available" v-for="(opt) in row.values" :key="opt.name">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ opt.name }} <small>{{ opt.available ? '' : '(no disponible)' }}</small></v-list-item-title>
                                        <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                    </v-list-item-content>

                                    <div class="d-flex align-center mr-3" v-if="row.ifQuantity">
                                        <v-btn
                                            small
                                            :disabled="opt.quantity<=0"
                                            @click="changeQtyMultiple(row, opt, -1)"
                                        >
                                            <v-icon dark>
                                                mdi-minus
                                            </v-icon>
                                        </v-btn>
                                        <v-sheet
                                            height="28"
                                            width="60"
                                            class="sheet-cant"
                                        >
                                            {{ opt.quantity }}
                                        </v-sheet>
                                        <v-btn
                                            small
                                            :disabled="(opt.quantity<=0 && (row.tmpVal).length >= row.select) || (row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) >= row.selectQuantity)"
                                            @click="changeQtyMultiple(row, opt, 1)"
                                        >
                                            <v-icon dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                    </div>

                                    <span :id="`${opt.name.replace(' ', '-')}_${opt.price}`" :data-details="`${opt.name}:${opt.price}:${(row.quantities)?(opt.quantity*quantity):opt.quantity}`"></span>

                                    <!-- con cantidad, la selección se hace con +/- (cantidad > 0 = seleccionado) -->
                                    <v-list-item-action v-if="!row.ifQuantity">
                                        <v-checkbox
                                            v-model="row.tmpVal"
                                            :value="`${opt.name.replace(' ', '-')}_${opt.price}`"
                                            :color="btnColor"
                                            :disabled=" ((row.tmpVal).includes(`${opt.name.replace(' ', '-')}_${opt.price}`)) ? false : ((row.tmpVal).length >= row.select) "
                                            @change="changeRespMultiple"
                                        ></v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                        </v-list>
                        <!-- multiple end -->
                        <!-- only -->
                        <v-list :key="j+20" v-if="row.type == 'only'">
                            <v-list-item-group
                                v-model="row.tmpValOnly"
                                active-class=""
                                :mandatory="!!row.isRequired"
                                @change="beforeChangeRespOnly(row, $event)"
                            >
                                <v-list-item :disabled="!opt.available" v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+((row.quantities)?(opt.price*quantity):opt.price)">
                                    <template v-slot:default="{ active }">
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ opt.name }} <small>{{ opt.available ? '' : '(no disponible)' }}</small>
                                                <span class="error--text" v-if="outOfStock[row.id] == `${row.id}-${slugify(opt.name)}`">(agotado)</span>
                                            </v-list-item-title>
                                            <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                            <v-list-item-subtitle v-if="(+opt.price)<0">{{ money }} ({{ opt.price }})</v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-icon :color="btnColor" v-if="active">
                                                mdi-circle-slice-8
                                            </v-icon>
                                            <v-icon v-else>
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                        <!-- only end -->
                    </template>

                    <v-divider></v-divider>

                    <!-- services -->
                    <v-card v-if="typeProd=='service' || typeStore=='real_estate'" tile elevation="0" id="content_reservation">
                        <v-card-text class="pa-0">
                            <v-card-title v-if="typeProd=='service'" class="py-3 blue-grey lighten-5">
                                {{ $t('Reserva tu hora') }}
                            </v-card-title>
                            <v-card-title v-if="typeStore=='real_estate' && typeProd=='product'" class="py-3 blue-grey lighten-5">
                                {{ $t('Agendar cita') }}
                            </v-card-title>
                            <v-form ref="refService" lazy-validation class="pa-3">
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            :label="$t('Nombre completo *')"
                                            :color="btnColor"
                                            outlined
                                            dense
                                            v-model="fullName"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <vue-tel-input-vuetify
                                            :label="$t('Celular *')"
                                            :color="btnColor"
                                            outlined
                                            dense
                                            :defaultCountry="iso2"
                                            :onlyCountries="enabledCountries"
                                            :rules="[rules.required]"
                                            :value="tmpPhone"
                                            @input="onInput"
                                        ></vue-tel-input-vuetify>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-dialog
                                            ref="dialog"
                                            v-model="menu1"
                                            :return-value.sync="dateFormatted"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <!-- @blur="dateReservation = parseDate(dateFormatted)" -->
                                            <v-text-field
                                                v-model="dateFormatted"
                                                :label="$t('Fecha *')"
                                                append-icon="mdi-calendar"
                                                dense
                                                outlined
                                                readonly
                                                :color="btnColor"
                                                :rules="[rules.required]"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="dateReservation"
                                                locale="es-Bo"
                                                :color="btnColor"
                                                class="ma-0"
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    :color="btnColor"
                                                    @click="menu1 = false"
                                                >
                                                    {{ $t('Cancelar') }}
                                                </v-btn>
                                                <v-btn
                                                    :color="btnColor"
                                                    :style="`color:${textbtnColor}`"
                                                    @click="$refs.dialog.save(formatDate(dateReservation)), getHoursMinsAvailable()"
                                                >
                                                    {{ $t('OK') }}
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-dialog
                                            ref="dialog2"
                                            v-model="menu2"
                                            :return-value.sync="timeReservation"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="timeReservation"
                                                :label="$t('Hora *')"
                                                append-icon="mdi-clock-time-four-outline"
                                                readonly
                                                outlined
                                                dense
                                                :color="btnColor"
                                                :rules="[rules.required]"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="menu2"
                                                v-model="timeReservation"
                                                full-width
                                                :color="btnColor"
                                                class="ma-0"
                                                :allowed-minutes="typeProd=='service' ? undefined : [0, 15, 30, 45]"
                                                :allowed-hours="availableHours"
                                            >
                                                <!-- format="24hr" -->
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    :color="btnColor"
                                                    @click="menu2 = false"
                                                >
                                                    {{ $t('Cancelar') }}
                                                </v-btn>
                                                <v-btn
                                                    :color="btnColor"
                                                    :style="`color:${textbtnColor}`"
                                                    @click="$refs.dialog2.save(timeReservation)"
                                                >
                                                    {{ $t('OK') }}
                                                </v-btn>
                                            </v-time-picker>
                                        </v-dialog>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </v-card>

                    <div class="px-3 pt-5">
                        <v-textarea
                            outlined
                            :placeholder="typeProd=='service'?$t('Incluir un comentario para la reserva'):$t('Dato extra')"
                            :color="btnColor"
                            rows="3"
                            v-model="dataExtra"
                        ></v-textarea>
                    </div>

                    <v-card-title class="py-3 blue-grey lighten-5" v-if="enablePaymentMethod && typeProd=='service'">
                        {{ $t('Método de pago') }}
                    </v-card-title>
                    <div class="pa-3" v-if="enablePaymentMethod && typeProd=='service'">
                        <div class="text-center">
                            <v-img
                                :src="codePaymentMethod"
                                max-width="300px"
                                class="mx-auto mb-2"
                            ></v-img>
                            <!-- <a :href="codePaymentMethod" download :style="`color: ${btnColor}`">Descargar QR</a> -->
                            <v-btn
                                :href="codePaymentMethod"
                                download
                                :color="btnColor"
                                dark
                                small
                                class="mb-2"
                            >
                                {{ $t('Descargar QR') }}
                            </v-btn>
                            <p class="mb-0">{{ $t('Banco') }}: {{ payment.bank }}</p>
                            <p class="mb-0">{{ $t('Cuenta') }}: {{ payment.account }}</p>
                            <p class="mb-0">{{ $t('Nombre') }}: {{ payment.name }}</p>
                            <p class="mb-10">{{ $t('NIT') }}: {{ payment.nit }}</p>
                        </div>
                    </div>

                </v-card-text>

                <v-card-actions class="pa-actions" v-if="!emergency">
                    <!-- product -->
                    <v-row no-gutters align="center" v-if="typeProd=='product' && typeStore!='real_estate'">
                        <v-col cols="6">
                            <div class="d-flex align-center" v-if="funCart">
                                <v-btn icon small @click="changePlusAndMinus('minus')" :disabled="quantity<=1">
                                    <v-icon dark>
                                        mdi-minus
                                    </v-icon>
                                </v-btn>
                                <v-text-field
                                    :placeholder="$t('Cantidad')"
                                    :color="btnColor"
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    step="1"
                                    :max="stock"
                                    hide-details
                                    v-model="quantity"
                                    style="width:100px;max-width:100px;"
                                    disabled
                                    @input="changeQuantity($event)"
                                ></v-text-field>
                                <v-btn icon small @click="changePlusAndMinus('plus')" :disabled="quantity>=stock">
                                    <v-icon dark>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <template v-if="funCart">
                                <v-btn
                                    large
                                    block
                                    rounded
                                    :color="btnColor"
                                    :style="`color:${textbtnColor}`"
                                    @click="addToCart"
                                    class="text-capitalize"
                                    :disabled="disabledBtn"
                                >
                                    <strong>{{ money }} {{ ((quantity * price) + respMultipleVal + respOnlyVal).toFixed(2).replace(/\.00$/, '') }}</strong>
                                </v-btn>
                            </template>
                            <v-btn
                                dark
                                large
                                block
                                rounded
                                v-if="consultWps"
                                color="#43bf51"
                                class="text-capitalize mt-2"
                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%20https://${tempHost}/${slug}?product=${prodId}%0a`"
                                target="_blank"
                                :disabled="disabledBtn"
                            >
                                <strong>{{ $t('Consultar') }}</strong>
                                <v-icon right>
                                    mdi-whatsapp
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <!-- services -->
                    <v-row no-gutters align="center" v-if="typeProd=='service'">
                        <v-col cols="12" v-if="tempMode=='order_generate'">
                            <v-btn
                                large
                                block
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                class="text-capitalize mb-2"
                                @click="openPreviewReservation"
                            >{{ $t('Generar reserva') }}</v-btn>
                            <v-btn
                                dark
                                large
                                block
                                rounded
                                v-if="consultWps"
                                color="#43bf51"
                                class="text-capitalize mt-2"
                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%20https://${tempHost}/${slug}?product=${prodId}%0a`"
                                target="_blank"
                            >
                                <strong>{{ $t('Consultar') }}</strong>
                                <v-icon right>
                                    mdi-whatsapp
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" v-else>
                            <v-btn
                                large
                                block
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                @click="sendServices"
                                class="text-capitalize"
                                :loading="loadingServ"
                            >
                                <strong>{{ $t('Reservar') }}</strong>
                            </v-btn>
                            <v-btn
                                dark
                                large
                                block
                                rounded
                                v-if="consultWps"
                                color="#43bf51"
                                class="text-capitalize mt-2"
                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%20https://${tempHost}/${slug}?product=${prodId}%0a`"
                                target="_blank"
                            >
                                <strong>{{ $t('Consultar') }}</strong>
                                <v-icon right>
                                    mdi-whatsapp
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <!-- mobiliario -->
                    <v-row no-gutters align="center" v-if="typeStore=='real_estate' && typeProd=='product'">
                        <v-col cols="12" v-if="tempMode=='order_generate'">
                            <v-btn
                                large
                                block
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                class="text-capitalize mb-2"
                                @click="openPreviewReservation"
                            >{{ $t('Generar cita') }}</v-btn>
                            <v-btn
                                dark
                                large
                                block
                                rounded
                                v-if="consultWps"
                                color="#43bf51"
                                class="text-capitalize mt-2"
                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%20https://${tempHost}/${slug}?product=${prodId}%0a`"
                                target="_blank"
                            >
                                <strong>{{ $t('Consultar') }}</strong>
                                <v-icon right>
                                    mdi-whatsapp
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" v-else>
                            <v-btn
                                large
                                block
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                @click="sendServices"
                                class="text-capitalize"
                                :loading="loadingServ"
                            >
                                <strong>{{ $t('Reservar') }}</strong>
                            </v-btn>
                            <v-btn
                                dark
                                large
                                block
                                rounded
                                v-if="consultWps"
                                color="#43bf51"
                                class="text-capitalize mt-2"
                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%20https://${tempHost}/${slug}?product=${prodId}%0a`"
                                target="_blank"
                            >
                                <strong>{{ $t('Consultar') }}</strong>
                                <v-icon right>
                                    mdi-whatsapp
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end dialog -->

        <!-- generate -->
        <v-dialog
            v-model="dialogGenerate"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-card-title>
                    {{ typeProd=='service' ? $t('Vista previa del pedido') : $t('Vista previa de la cita') }}
                </v-card-title>
                <v-card-text>
                    <div style="white-space: break-spaces;" v-html="contentOrder"></div>
                </v-card-text>
                <v-card-actions class="pa-actions">
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        large
                        text
                        color="error"
                        class="text-capitalize"
                        @click="dialogGenerate=false"
                    >{{ $t('Volver') }}</v-btn>
                    <v-btn
                        dark
                        large
                        rounded
                        color="#43bf51"
                        class="text-capitalize"
                        @click="sendReservationWhatsApp('service')"
                        v-if="typeProd=='service'"
                    >
                        <v-icon left>
                            mdi-whatsapp
                        </v-icon>
                        {{ $t('Enviar reserva') }}
                    </v-btn>
                    <v-btn
                        dark
                        large
                        rounded
                        color="#43bf51"
                        class="text-capitalize"
                        @click="sendReservationWhatsApp('appointment')"
                        v-else
                    >
                        <v-icon left>
                            mdi-whatsapp
                        </v-icon>
                        {{ $t('Reservar cita') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- generate END -->

        <!-- video -->
        <v-dialog
            v-model="dialogVideo"
            width="800"
            scrollable
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-btn
                    fab
                    small
                    absolute
                    right
                    style="z-index:1;top:10px;"
                    @click="dialogVideo = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <iframe width="100%" :height="($vuetify.breakpoint.smAndUp)?500:300" :src="`https://www.youtube.com/embed/${codeVideo}?rel=0&showinfo=0&controls=0&autoplay=1&autohide=0&loop=1`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </v-card>
        </v-dialog>
        <!-- video END -->
    </v-container>
</template>
<script>
import axios from 'axios'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';
// Vue.use(VueTelInputVuetify);
import DomPurify from 'dompurify'

export default {
    components: {
        VueTelInputVuetify,
    },
    data() {
        return {
            tempHost: window.location.host,
            overlayProd: false,
            loadProd: true,
            dialogProd: false,
            prodId: '',
            bannerProd: '',
            galleryProd: [],
            nameProd: '',
            storeShowName: '',
            typeProd: '',
            descriptionProd: '',
            optionsProd: [],
            quantity: 1,
            price: null,
            tmpPrice: null,
            priceNormal: null,
            stock: 500,
            dataExtra: '',
            respMultiple: [],
            respMultipleVal: 0,
            respOnly: [],
            respOnlyVal: 0,
            showRequired: false,
            showAlertRequired: false,
            extraBtn: {},
            dialogVideo: false,
            codeVideo: '',
            // reservation
            menu1: false,
            menu2: false,
            fullName: '',
            phoneNumber: '',
            tmpPhone: '',
            phoneCode: '',
            phoneValid: false,
            dateReservation: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            timeReservation: '14:00',
            availableHours: [],
            loadingServ: false,
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                requiredDates: v => v.length>0 || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
            // generate
            dialogGenerate: false,
            contentOrder: '',
            // qr code
            enablePaymentMethod: false,
            codePaymentMethod: '',
            payment: {
                bank: '',
                account: '',
                name: '',
                nit: ''
            },
            wholesalePrices: [],
            extraComplement: [],
            tmpCombination: {},
            disabledBtn: false,
            tmpPriceCombination: null,
            outOfStock: [],
            enabledCountries: ['bo']
        }
    },
    props: [
        'slug',
        'titleColor',
        'titleCardColor',
        'priceColor',
        'btnColor',
        'textbtnColor',
        'bannerColor',
        'textnavColor',
        'navColor',
        'fontFamily',
        'dataMyStore',
        'consultWps',
        'storePhone',
        'codePhone',
        'storeName',
        'emergency',
        'money',
        'ifLoadMore',
        'contentColor',
        'tempMode',
        'searchProd',
        'loading2',
        'to',
        'total',
        'mobileColumns',
        'desktopColumns',
        'funCart',
        'locationMap',
        'typeStore',
        'inventory',
        'openProductNewTab',
        'isDomain',
        'iso2'
    ],
    mounted() {
        this.getMainData()

        // obtener el parametro product de la url
        const currentUrl = window.location.href
        const url = new URL(currentUrl)
        const idFromUrl = url.searchParams.get('product')
        if (idFromUrl) {
            // console.log(idFromUrl);
            setTimeout(() => {
                this.openDetails(idFromUrl)
            }, 500);
        }

        this.getHoursMinsAvailable()
    },
    computed: {
        computedDateFormatted () {
            return this.formatDate(this.date)
        },
    },
    watch: {
        dialogProd(e) {
            if (!e) {
                this.respMultiple = []
                this.respMultipleVal = 0

                this.respOnly = []
                this.respOnlyVal = 0

                this.dataExtra = ''

                this.optionsProd = []
            }
        },
        dateReservation (val) {
            this.dateFormatted = this.formatDate(this.date)
        },
        dialogVideo(e) {
            if (!e) {
                this.codeVideo = ''
            }
        },
        quantity(newVal, oldVal) {
            if ((+newVal) > (+oldVal)) {
                if (this.wholesalePrices.length > 0) this.calculateNewPrice('plus')
            }
            if ((+newVal) < (+oldVal)) {
                if (this.wholesalePrices.length > 0) this.calculateNewPrice('minus')
            }
        }
    },
    methods: {
        onInput(formattedNumber, { number, valid, country }) {
            this.phoneCode = '+'+country.dialCode
            this.phoneNumber = number.significant
            this.tmpPhone = number.international
            this.phoneValid = valid
        },


        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        getComplementsTitles() {
            // nombre de la opción -> título del complemento, para los mensajes de WhatsApp
            const titles = { multi: {}, only: {} }
            this.optionsProd.forEach(row => {
                const group = (row.type == 'multiple') ? titles.multi : titles.only
                row.values.forEach(opt => { group[opt.name] = row.title })
            })
            return titles
        },
        changeQtyMultiple(row, opt, step) {
            const key = `${opt.name.replace(' ', '-')}_${opt.price}`
            const newQty = Math.max(0, opt.quantity + step)
            // respetar la cantidad máxima de todos los complementos juntos
            if (step > 0 && row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) + step > row.selectQuantity) return
            const isSelected = row.tmpVal.includes(key)

            if (newQty > 0 && !isSelected) {
                // respetar el máximo de opciones permitidas
                if (row.tmpVal.length >= row.select) return
                row.tmpVal.push(key)
            }
            if (newQty == 0 && isSelected) {
                row.tmpVal.splice(row.tmpVal.indexOf(key), 1)
            }

            opt.quantity = newQty
            this.changeRespMultiple()
        },
        changeRespMultiple() {
            this.verifyRequireds()
            setTimeout(() => {
                var tmpListComplements = []
                this.optionsProd.forEach(element => {
                    element.tmpVal.forEach(val => {
                        const selectedId = document.getElementById(val)
                        const dataSelected = selectedId.getAttribute('data-details')
                        tmpListComplements.push(dataSelected)
                    });
                });
                // console.log(tmpListComplements);
                this.respMultipleVal = 0
                if (tmpListComplements.length > 0) {
                    tmpListComplements.forEach(el => {
                        // console.log(el);
                        let valSelected = el.split(':')
                        let tmpPrice = (+valSelected[1]) * (+valSelected[2])
                        this.respMultipleVal += tmpPrice
                    });
                }
                this.respMultiple = tmpListComplements
            }, 500);
        },

        /**
         * before
         */
        slugify(text) {
            return text
                .toString()
                .normalize("NFD")                   // separa los acentos de las letras
                .replace(/[\u0300-\u036f]/g, "")    // elimina los acentos
                .toLowerCase()                      // convierte a minúsculas
                .trim()                             // elimina espacios al inicio y final
                .replace(/\s+/g, '-')               // reemplaza espacios por guiones
                .replace(/[^\w\-]+/g, '')           // elimina caracteres no alfanuméricos excepto guiones
                .replace(/\-\-+/g, '-');            // reemplaza múltiples guiones por uno solo
        },
        async verifyStock(barcode) {
            let stk = 0
            let prc = 0
            await axios.post('/verify-stock', {barcode: barcode, slug: this.slug})
            .then((response) => {
                // console.log(response);
                stk = response.data?.internal_stock
                prc = (response.data?.special_price && response.data?.special_price > 0) ? response.data?.special_price : response.data?.price
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
            return {
                stock: stk,
                price: prc
            }
        },
        async beforeChangeRespOnly(row, e) {
            this.outOfStock = []
            // Si no es requerido, Vuetify permite desmarcar y el evento llega undefined.
            // En ese caso, solo limpiamos estados relacionados y seguimos.
            if (!e) {
                if (this.tmpCombination && this.tmpCombination[row.id]) {
                    delete this.tmpCombination[row.id]
                }
                this.changeRespOnly()
                return
            }
            if (this.typeStore == 'product' && (+this.inventory) && this.extraComplements) {
                
                const idsComplements = [...new Set(this.extraComplements.map(el => el.ids).flat())]
                if (idsComplements.includes(row.id)) {
                    // obtener el valor seleccionado
                    this.tmpCombination[row.id] = e.split(':')[0]
                    // convertir el objeto en un array
                    const arrayComplements = Object.values(this.tmpCombination)
                    // ordenar el array
                    const arrayOrderComplements = [...arrayComplements].sort((a, b) => a.length - b.length)

                    // encontrar el complemento extra
                    const fiindExtraComplement = this.extraComplements.find(item =>
                        JSON.stringify(item.names.sort((a, b) => a.length - b.length)) === JSON.stringify(arrayOrderComplements)
                    )

                    if (fiindExtraComplement) {
                        // asignar el complemento extra
                        if (fiindExtraComplement.barcode=='') {
                            this.disabledBtn = true
                            this.price = this.tmpPriceCombination

                            this.outOfStock[row.id] = `${row.id}-${this.slugify(e.split(':')[0])}`
                        } else {
                            const stkprc = await this.verifyStock(fiindExtraComplement.barcode)
                            const stk = stkprc.stock
                            const prc = stkprc.price

                            if (stk > 0) {
                                this.disabledBtn = false
                                this.price = prc
                                this.priceNormal = prc
                                // if (fiindExtraComplement.price != '') {
                                //     this.price = +fiindExtraComplement.price
                                // } else {
                                //     this.price = this.tmpPriceCombination
                                // }
                            } else {
                                this.outOfStock = []
                                this.disabledBtn = true
                                this.price = this.tmpPriceCombination
                                this.outOfStock[row.id] = `${row.id}-${this.slugify(e.split(':')[0])}`
                            }
                        }
                    }
                }
            }
            this.changeRespOnly()
        },
        changeRespOnly() {
            this.verifyRequireds()
            const tmpListOnly = []
            this.optionsProd.forEach(element => {
                if (element.tmpValOnly) {
                    tmpListOnly.push(element.tmpValOnly)
                }
            });

            this.respOnlyVal = 0
            if (tmpListOnly.length > 0) {
                tmpListOnly.forEach(el => {
                    let tmpPrice = +(el.split(':')[1])
                    this.respOnlyVal += tmpPrice
                });
            }
            // console.log(tmpListOnly);
            this.respOnly = tmpListOnly
        },
        verifyRequireds() {
            this.showRequired = false
            for (let i = 0; i < this.optionsProd.length; i++) {
                const element = this.optionsProd[i];
                //console.log(this.optionsProd);
                //console.log(element);
                //console.log(`title: ${element.title} | type: ${element.type} | tmpValOnly: ${element.tmpValOnly}`);
                if (element.isRequired) {
                    if (element.type == 'multiple') this.showRequired = (element.tmpVal.length<=0)
                    if (element.type == 'only') this.showRequired = (element.tmpValOnly==undefined)
                }
                if (this.showRequired) break
            }
        },
        openDetails(id) {
            if (this.openProductNewTab) {
                window.open(`/${this.slug}/product/${id}`, '_self');
                return
            }

            setTimeout(() => {
                if (this.typeStore == 'real_estate' && this.typeProd == 'product') {
                    // const tempDate = new Date()
                    this.timeReservation = '00:00'
                } else {
                    this.timeReservation = '14:00'
                }
            }, 1000);

            
            this.loadProd = true
            this.wholesalePrices = []
            this.tmpCombination = {}
            this.disabledBtn = false
            // this.dialogProd = true
            axios.get(`/show-product/${id}?store=${this.slug}`)
            .then((response) => {
                // console.log(response);
                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                // if (response.data.gallery.length > 0) {
                //     this.bannerProd = response.data.banner
                // }
                this.nameProd = response.data.name
                this.storeShowName = response.data.store_show_name

                this.typeProd = response.data.type
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpVal = JSON.parse(element.values)
                        var multiRequired = []
                        var onlyRequired = undefined
                        tmpVal.forEach(val => {
                            // multiple con cantidad empieza en 0 (no seleccionado)
                            val.quantity = (element.type == 'multiple' && element.quantity) ? 0 : 1
                        });
                        if (element.type == 'multiple') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    // multiRequired.push(`${val.name}:${val.price}:${val.quantity}`)
                                    val.quantity = 1
                                    multiRequired.push(`${val.name.replace(' ', '-')}_${val.price}`)
                                    setTimeout(() => {
                                        this.changeRespMultiple()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        if (element.type == 'only') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    onlyRequired = val.name+':'+val.price
                                    setTimeout(() => {
                                        this.changeRespOnly()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        // const selectRequired = `${opt.name.replace(' ', '-')}_${opt.price}`
                        this.optionsProd.push({
                            id: element.id,
                            title: element.title,
                            type: element.type,
                            values: tmpVal,
                            select: element.select,
                            selectQuantity: (+element.select_quantity > 0) ? +element.select_quantity : null,
                            tmpVal: multiRequired,
                            tmpValOnly: onlyRequired,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false,
                            quantities: (element.quantities)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price
                this.tmpPrice = (response.data.special_price) ? response.data.special_price : response.data.price
                this.tmpPriceCombination = (response.data.special_price) ? response.data.special_price : response.data.price
                this.priceNormal = response.data.price??0;
                this.quantity = 1
                if (response.data.stock > 0) {
                    this.stock = response.data.stock
                }

                // extra boton
                this.extraBtn = {
                    isBtn: response.data.btn_extra,
                    textBtn: response.data.text_btn_extra,
                    typeBtn: response.data.type_btn_extra,
                    urlBtn: response.data.url_btn_extra
                }

                // precios por mayor
                this.wholesalePrices = response.data.wholesale_prices ? JSON.parse(response.data.wholesale_prices) : []

                // extra complements
                if (response.data.extra_complements.length > 0) {
                    this.extraComplements = JSON.parse(response.data.extra_complements[0].values)
                }

                this.dialogProd = true
                setTimeout(() => {
                    this.loadProd = false
                }, 800);
            })
            .catch((error) => {
                console.log(error);
            })
        },
        // chabge quantity
        changeQuantity(event) {
            if (+event <= 1) {
                this.quantity = 1
            }
            if (+event > this.stock) {
                this.$fire({
                    title: this.$t('Agotado'),
                    text: `${this.$t('Stock agotado, solo queda')} ${this.stock} ${this.$t('productos en almacén')}`,
                    type: this.$t('error'),
                    confirmButtonText: this.$t('Entendido'),
                    confirmButtonColor: this.btnColor,
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(resp => {
                    if (resp.value) {
                        this.quantity = this.stock
                        this.calcTotal()
                    }
                })
            }
            this.calcTotal()
        },
        updateQuantitysComplements() {
            this.optionsProd.forEach(element => {
                if (element.quantities) {
                    if (element.tmpValOnly) {
                        let tmp = element.tmpValOnly.split(':')
                        element.values.forEach(item => {
                            if (item.name == tmp[0]) tmp[1] = item.price
                        });
                        tmp[1] = tmp[1]*this.quantity
                        element.tmpValOnly = tmp.join(':')
                    }
                    if (element.tmpVal.length > 0) {
                        element.tmpVal.forEach(val => {
                            const selectedId = document.getElementById(val)
                            const dataSelected = selectedId.getAttribute('data-details')
                            let tmp2 = dataSelected.split(':')
                            element.values.forEach(item => {
                                if (item.name == tmp2[0]) tmp2[1] = item.price
                            });
                            tmp2[1] = tmp2[1]*this.quantity
                            selectedId.setAttribute('data-details', tmp2.join(':'))
                        });
                    }
                }
            });
            this.changeRespOnly()
            this.changeRespMultiple()
        },
        // change plus and minus
        changePlusAndMinus(type) {
            var tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.price) * ((+this.quantity)-1))
                    if (tmpImport < 0) {
                        this.$notify.error(this.$t('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.'))
                        return
                    }
                    this.quantity = (+this.quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.price) * ((+this.quantity)+1))
                    if (tmpImport < 0) {
                        this.$notify.error(this.$t('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.'))
                        return
                    }
                    this.quantity = (+this.quantity) + 1
                    break
                default:
                    break
            }

            this.updateQuantitysComplements()

            this.changeQuantity(this.quantity)
            this.calcTotal()
        },
        calculateNewPrice(type) {
            const minQuantity = this.wholesalePrices.reduce((min, item) => Math.min(min, item.quantity), Infinity);
            if (this.quantity < minQuantity) {
                this.price = this.tmpPrice
            } else {
                for (let i = 0; i < this.wholesalePrices.length; i++) {
                    const element = this.wholesalePrices[i];
                    if (type == 'plus' && this.quantity == element.quantity) {
                        this.price = element.price
                        break
                    }
                    if ((type == 'minus' && this.quantity > element.quantity) || this.quantity == element.quantity) {
                        this.price = element.price
                        // break
                    }
                }
            }
        },
        addToCart() {
            this.showAlertRequired = false
            if (this.showRequired) {
                this.showAlertRequired = true
                return
            }
            this.overlayProd = true
            const cart = {
                    prodId: this.prodId,
                    name: this.nameProd,
                    // price: this.price,
                    price: (this.quantity * this.price) + this.respMultipleVal + this.respOnlyVal,
                    priceNormal: (this.quantity * this.priceNormal) + this.respMultipleVal + this.respOnlyVal,
                    quantity: this.quantity,
                    extra: this.dataExtra,
                    complements: {
                        multi: this.respMultiple,
                        only: this.respOnly
                    },
                    complementsTitles: this.getComplementsTitles()
                }

            if (localStorage.getItem(this.slug)) {
                const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                var size = Object.keys(tmpCart).length;
                tmpCart[size] = cart
                // tmpCart[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCart))
            } else {
                let tmpCartInitial = {}
                tmpCartInitial[0] = cart
                // tmpCartInitial[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCartInitial))
            }

            this.$emit('update-cart', localStorage.getItem(this.slug))

            setTimeout(() => {
                this.overlayProd = false
                this.dialogProd = false
            }, 300);
            setTimeout(() => {
                this.$confirm(
                    '',
                    this.$t('Producto agregado correctamente.'),
                    'success', {
                    showCloseButton: true,
                    reverseButtons: true,
                    confirmButtonText: this.$t('Ver carrito'),
                    confirmButtonColor: this.btnColor,
                    cancelButtonText: this.$t('Seguir comprando'),
                    customClass: {
                        container: this.tmpFontFamily
                    }
                }).then(res => {
                    if (res) {
                        this.$emit('open-cart', true)
                    }
                });
            }, 500);
        },
        // calc total
        calcTotal() {
            // this.total = 0
            // this.listProdSelected.forEach(p => {
            //     this.total+=(p.price * p.quantity) - p.discount
            // });
            // this.data.payTotal = this.total.toFixed(2)
        },
        /**
         * service
         */
        sendServices() {
            if (this.$refs.refService.validate()) {
                this.$fire({
                    title: this.$t('Realizar reserva.'),
                    text: this.$t('Recibirá un mensaje por WhatsApp para coordinar mayor datos de su reserva.'),
                    type: 'info',
                    confirmButtonText: this.$t('Continuar'),
                    confirmButtonColor: this.btnColor,
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(async resp => {
                    if (resp.value) {
                        this.loadingServ = true
                        const dataForm = new FormData()
                        dataForm.append('full_name', this.fullName)
                        dataForm.append('phone_number', this.phoneNumber)
                        dataForm.append('dates', this.dateReservation)
                        dataForm.append('time', this.timeReservation)
                        dataForm.append('extra', this.dataExtra)
                        dataForm.append('store', this.slug)
                        dataForm.append('prod_id', this.prodId)
                        dataForm.append('complements', JSON.stringify(this.optionsProd))
                        dataForm.append('user', 'user')

                        await axios.post('/send-service', dataForm)
                        .then((response) => {
                            // console.log(response);
                            if (response.data == 'ok') {
                                this.$fire({
                                    title: this.$t('Reserva realizado con éxito.'),
                                    text: this.$t('Su reserva fue realizado con éxito, en un momento recibirá un mensaje de whatsapp para coordinar con mayor detalle el servicio.'),
                                    type: 'success',
                                    confirmButtonText: this.$t('Continuar'),
                                    confirmButtonColor: this.btnColor,
                                    reverseButtons: true,
                                    showCancelButton: false,
                                    customClass: {
                                        container: this.fontFamily
                                    }
                                }).then(resp => {
                                    if (resp.value) {
                                        window.location.href='/'+this.slug
                                    }
                                })
                                this.full_name = ''
                                this.phone_number = ''
                                this.dates = []
                                this.time = ''
                                this.extra = ''
                                this.dialogProd = false
                                this.loadingServ = false
                            }
                        })
                        .catch((error) => {
                            if (error.response.status == 404 || error.response.status == 500) {
                                this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                            }
                            this.loadingServ = false
                        })
                    }
                })
            }
        },
        /**
         * generate
         */
        // this.contentOrder = `SERVICIO de ${ this.nameProd }. \n ${ this.htmlToPlainText(this.descriptionProd) }
        openPreviewReservation() {
            if (this.$refs.refService.validate()) {
// generate text
let complementsTemp = ``;
if (this.optionsProd.length > 0) {
    this.optionsProd.forEach(option => {
        if (option.type == 'multiple') {
            if (option.tmpVal.length > 0) {
                option.tmpVal.forEach(el => {
                    complementsTemp += `${option.title}: ${el.split('_')[0]} \n`;
                });
            }
        }
        if (option.type == 'only') {
            if (option.tmpValOnly) {
                complementsTemp += `${option.title}: ${option.tmpValOnly.split(':')[0]} \n`;
            }
        }
    })
}
this.contentOrder = `${ this.typeProd == 'service' ? this.$t('SERVICIO de') : this.$t('de') } ${ this.nameProd }
${complementsTemp}
${this.$t('DATOS GENERALES')}
===============
${this.$t('Nombre')}: ${ this.fullName }
${this.$t('Celular')}: ${ this.phoneNumber }
${this.$t('Fecha')}: ${ this.dateFormatted }
${this.$t('Hora')}: ${ this.timeReservation }
${this.$t('Comentario extra')}: ${ this.dataExtra }

${ (this.locationMap!='') ? this.$t('VISITA NUESTRA TIENDA EN:')+' '+this.locationMap : '' }

`
// end
                this.dialogGenerate = true
            }  else {
                // scrool to top id content_reservation
                setTimeout(() => {
                    const elmnt = document.getElementsByClassName('error--text')[0];
                    const containerCard = document.getElementById('content_reservation');
                    if (elmnt && containerCard) {
                        const offset = 80;
                        const elementOffsetTop = elmnt.offsetTop;
                        containerCard.scrollTo({
                            top: elementOffsetTop - offset,
                            behavior: 'smooth'
                        });
                    }
                }, 300);
                
                // notify
                this.$notify.error(this.$t('Campos requeridos vacios'))
            }
        },
        // send
        async sendReservationWhatsApp(type) {
            this.loading = true
            const dataForm = new FormData()
            dataForm.append('full_name', this.fullName)
            dataForm.append('phone_number', this.phoneNumber)
            dataForm.append('dates', this.dateReservation)
            dataForm.append('time', this.timeReservation)
            dataForm.append('extra', this.dataExtra)
            dataForm.append('store', this.slug)
            dataForm.append('prod_id', this.prodId)
            dataForm.append('user', 'user')

            dataForm.append('wsp_order', this.contentOrder)

            await axios.post('/generate-'+type, dataForm)
            .then((response) => {
                // console.log(response)
                if (this.isDomain) {
                    // abrir en otra ventana
                    window.open(response.data, '_blank');
                } else {
                    //window.location.href = response.data
                    var link = document.createElement('a');
                    link.setAttribute('title', 'link');
                    link.setAttribute('href', response.data);
                    //link.setAttribute('target', "_blank");
                    link.click();
                }
                // window.location.href = response.data
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.loading = false
            })
        },
        htmlToPlainText(html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            return temp.textContent || temp.innerText || '';
        },
        /**
         * get data
         */
        async getMainData() {
            await axios.get(`/data-order/${this.slug}`)
            .then((response) => {
                // console.log(response)
                if (response.data[0]) {
                    const contentPayment = JSON.parse(response.data[0].content)
                    this.enablePaymentMethod = (contentPayment.enable)?true:false
                    this.codePaymentMethod = contentPayment.codeQr
                    this.payment.bank = contentPayment.bank
                    this.payment.account = contentPayment.account
                    this.payment.name = contentPayment.name
                    this.payment.nit = contentPayment.nit
                }
                if (response.data[16]) {
                    const contentCountryCodes = JSON.parse(response.data[16].content)
                    this.enabledCountries = contentCountryCodes
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },

        /**
         * copiar enlace en portapapeles
         */
        copyData(txt) {
            const txtresult = window.location.origin+txt;
            const el = document.createElement("textarea");
            el.value = txtresult;
            const content = document.querySelector(".wrap-copy");
            content.append(el);
            el.select();
            document.execCommand("copy");
            el.remove();

            this.$notify.success(this.$t('El enlace ha sido copiado exitósamente.'));
        },
        copyData2(txt) {
            const txtresult = window.location.origin+txt;
            const el = document.createElement("textarea");
            el.value = txtresult;
            const content = document.querySelector(".wrap-copy2");
            content.append(el);
            el.select();
            document.execCommand("copy");
            el.remove();

            this.$notify.success(this.$t('El enlace ha sido copiado exitósamente.'));
        },
        /**
         * horas disponibles
         */
        async getHoursMinsAvailable() {
            await axios.post(`/admin/hours-mins-available/${this.slug}`,
                { date: this.dateReservation }
            )
            .then((response) => {
                // console.log(response)
                this.availableHours = response.data
            })
            .catch((error) => {
                // console.log(error)
                this.availableHours = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]
            })
        },
        sanitize(value) {
            return DomPurify.sanitize(value)
        }
    }
}
</script>
<style lang="scss">
.sheet-cant {
    text-align: center;
    border: 1px solid #9e9e9e !important;
    font-size: 16px;
    line-height: 25px;
    border-radius: 4px;
}
.break-word {
    word-break: break-all;
}
</style>
